<template>
  <div>

    qColumnHeader = {{ qColumnHeader }}<br /><br />
    qColumns = {{ qColumns }}<br /><br />

    <v-layout row wrap v-if="qColumns && 1 === qColumns.length">
      <v-flex xs6 />
      <v-flex xs2>
        <p class="column-header" v-html="qColumnHeader"></p>
      </v-flex>
      <v-flex xs4 />
    </v-layout>

    <v-layout row wrap v-else-if="qColumns && 2 === qColumns.length">
      <v-flex xs6 />
      <v-flex xs6>
        <p class="column-header" v-html="qColumnHeader"></p>
      </v-flex>
      <v-flex xs0 />
    </v-layout>

      <v-layout row wrap v-else-if="qColumns && 3 === qColumns.length">
      <v-flex xs5 />
      <v-flex xs2>
        <p class="column-header" v-html="qColumnHeader"></p>
      </v-flex>
      <v-flex xs1 />
    </v-layout>

    <v-layout row wrap v-else-if="qColumns && 4 === qColumns.length">
      <v-flex xs4 />
      <v-flex v-for="col in qColumns" :key="col.colHeader" xs8>
        <p class="column-header">
          ({{ col.id }})
          <br />
          {{ col.label }}
        </p>
      </v-flex>
      <v-flex xs0 />
    </v-layout>

    <v-layout row wrap v-else-if="qColumns && 5 === qColumns.length">
      <v-flex xs7 />
      <v-flex v-for="col in qColumns" :key="col.colHeader" xs1>
        <p class="column-header">
          ({{ col.id }})
          <br />
          {{ col.label }}
        </p>
      </v-flex>
      <v-flex xs0 />
    </v-layout>

    <v-layout row wrap v-else-if="qColumns && 6 === qColumns.length">
      <v-flex xs4 />
      <v-flex v-for="col in qColumns" :key="col.colHeader" xs2>
        <p class="column-header">
          ({{ col.id }})
          <br />
          {{ col.label }}
        </p>
      </v-flex>
      <v-flex xs6 />
    </v-layout>

    <v-layout row wrap v-else>
      <v-flex xs5 />
      <v-flex v-for="col in qColumns" :key="col.colHeader" xs2>
        <p class="column-header">
          ({{ col.id }})
          <br />
          {{ col.label }}
        </p>
      </v-flex>
      <v-flex xs5 />
    </v-layout>

  </div>
</template>

<script>
export default {
  name: "AnswersColumns1",
  props: {
		columns: Array,
		columnHeader: String,
    qId: String
  },
  data: () => ({
		qColumns: [],
		qColumnHeader: null
  }),
  watch: {
    columns: function (newVal, oldVal) {
      this.qColumns = newVal;
		},
		columnHeader: function (newVal, oldVal) {
			this.qColumnHeader = newVal;
		}
  }
};
</script>

<style scoped>
.column-header {
  text-align: center;
  font-weight: bold;
}
</style>
